export function getdata() {
	var obj = {
			headDataI: [{
					title: "",
					prop: 'title',
					width: "200px",
					custom: true,
					fixed:'left'
				}, {
					title: "",
					prop: 'mintitle',
					width: "200px",
					custom: true,
					fixed:'left'

				}, {
					title: "",
					prop: "groud",
					width: "200px",
					custom: true,
					fixed:'left'

				}
			],
			tableDataI: [
				{
					title:"*税源编号",
					mintitle:"",
					groud:"(1)"
				},
				{
					title:"*排放口编号",
					mintitle:"",
					groud:"(2)"
				},
				{
					title:"*排放口名称或噪声源名称",
					mintitle:"",
					groud:"(3)"
				},
				{
					title:"*生产经营所在街乡",
					mintitle:"",
					groud:"(4)"
				},
				{
					title:"排放口地理坐",
					mintitle:"*经度",
					groud:"(5)"
				},
				{
					title:"排放口地理坐",
					mintitle:"*纬度",
					groud:"(6)"
				},
				{
					title:"*有效期起止",
					mintitle:"",
					groud:"(7)"
				},
				{
					title:"*污染物类别",
					mintitle:"",
					groud:"(8)"
				},
				{
					title:"水污染物种类",
					mintitle:"",
					groud:"(9)"
				},
				{
					title:"*污染物名称",
					mintitle:"",
					groud:"(10)"
				},
				{
					title:"危险废物污染物子类",
					mintitle:"",
					groud:"(11)"
				},
				{
					title:"*污染物排放量计算方法",
					mintitle:"",
					groud:"(12)"
				},
				{
					title:"大气、水污染物标准排放限值",
					mintitle:"*执行标准",
					groud:"(13)"
				},
				{
					title:"大气、水污染物标准排放限值",
					mintitle:"*标准浓度值（毫克/升或毫克/标立方米）",
					groud:"(14)"
				},
				{
					title:"产（排）污系数",
					mintitle:"*计税基数单位",
					groud:"(15)"
				},
				{
					title:"产（排）污系数",
					mintitle:"*污染物单位",
					groud:"(16)"
				},
				{
					title:"产（排）污系数",
					mintitle:"*产污系数",
					groud:"(17)"
				},
				{
					title:"产（排）污系数",
					mintitle:"*排污系数",
					groud:"(18)"
				},
				{
					title:"固体废物信息",
					mintitle:"贮存情况",
					groud:"(19)"
				},
				{
					title:"固体废物信息",
					mintitle:"处置情况",
					groud:"(20)"
				},
				{
					title:"固体废物信息",
					mintitle:"综合利用情况",
					groud:"(21)"
				},
				{
					title:"噪声信息",
					mintitle:"*是否昼夜产生",
					groud:"(22)"
				},
				{
					title:"噪声信息",
					mintitle:"*标准值——昼间(6 时至 22 时)",
					groud:"(23)"
				},
				{
					title:"噪声信息",
					mintitle:"*标准值——夜间(22时至次日 6 时)",
					groud:"(24)"
				},
			],
			headDataII: [{
					title: "",
					prop: 'title',
					width: "200px",
					custom: true,
					fixed:'left'

				}, {
					title: "",
					prop: 'mintitle',
					width: "200px",
					custom: true,
					fixed:'left'

				}, {
					title: "",
					prop: "groud",
					width: "200px",
					custom: true,
					fixed:'left'

				}, {
					title: "",
					prop: "ccxwhb_4_x_1",
					width: "200px",
					custom: true,
				}, {
					title: "",
					prop: "ccxwhb_4_x_2",
					width: "200px",
					custom: true,
				}, {
					title: "",
					prop: "ccxwhb_4_x_3",
					width: "200px",
					custom: true,
				}, {
					title: "",
					prop: "ccxwhb_4_x_4",
					width: "200px",
					custom: true,
				},{
					title: "",
					prop: "ccxwhb_4_x_5",
					width: "200px",
					custom: true,
				},{
					title: "",
					prop: "ccxwhb_4_x_6",
					width: "200px",
					custom: true,
				},{
					title: "",
					prop: "ccxwhb_4_x_7",
					width: "200px",
					custom: true,
				},{
					title: "",
					prop: "ccxwhb_4_x_8",
					width: "200px",
					custom: true,
				},{
					title: "",
					prop: "ccxwhb_4_x_9",
					width: "200px",
					custom: true,
				},{
					title: "",
					prop: "ccxwhb_4_x_10",
					width: "200px",
					custom: true,
				},{
					title: "",
					prop: "ccxwhb_4_x_11",
					width: "200px",
					custom: true,
				},{
					title: "",
					prop: "ccxwhb_4_x_12",
					width: "200px",
					custom: true,
				},{
					title: "",
					prop: "ccxwhb_4_x_13",
					width: "200px",
					custom: true,
				},{
					title: "",
					prop: "ccxwhb_4_x_14",
					width: "200px",
					custom: true,
				},{
					title: "",
					prop: "ccxwhb_4_x_15",
					width: "200px",
					custom: true,
				},{
					title: "",
					prop: "ccxwhb_4_x_16",
					width: "200px",
					custom: true,
				},{
					title: "",
					prop: "ccxwhb_4_x_17",
					width: "200px",
					custom: true,
				},{
					title: "",
					prop: "ccxwhb_4_x_18",
					width: "200px",
					custom: true,
				},{
					title: "",
					prop: "ccxwhb_4_x_19",
					width: "200px",
					custom: true,
				},{
					title: "",
					prop: "ccxwhb_4_x_20",
					width: "200px",
					custom: true,
				},{
					title: "",
					prop: "ccxwhb_4_x_21",
					width: "200px",
					custom: true,
				},{
					title: "",
					prop: "ccxwhb_4_x_22",
					width: "200px",
					custom: true,
				},{
					title: "",
					prop: "ccxwhb_4_x_23",
					width: "200px",
					custom: true,
				},{
					title: "",
					prop: "ccxwhb_4_x_24",
					width: "200px",
					custom: true,
				},{
					title: "",
					prop: "ccxwhb_4_x_25",
					width: "200px",
					custom: true,
				},{
					title: "",
					prop: "ccxwhb_4_x_26",
					width: "200px",
					custom: true,
				},{
					title: "",
					prop: "ccxwhb_4_x_27",
					width: "200px",
					custom: true,
				},
			],
			tableDataII: [
				{
					title:"*税源编号",
					mintitle:"",
					groud:"(1)"
				},
				{
					title:"*税款所属月份",
					mintitle:"",
					groud:"(2)"
				},
				{
					title:"*排放口名称或噪声源名称",
					mintitle:"",
					groud:"(3)"
				},
				{
					title:"*污染物类别",
					mintitle:"",
					groud:"(4)"
				},
				{
					title:"*水污染物种类",
					mintitle:"",
					groud:"(5)"
				},
				{
					title:"*污染物名称",
					mintitle:"",
					groud:"(6)"
				},
				{
					title:"危险废物污染物子类",
					mintitle:"",
					groud:"(7)"
				},
				{
					title:"*污染物排放量计算方法",
					mintitle:"",
					groud:"(8)"
				},
				{
					title:"大气、水污染物监测计算",
					mintitle:"*废气（废水）排放量（万标立方米、吨）",
					groud:"(9)"
				},
				{
					title:"大气、水污染物监测计算",
					mintitle:"*实测浓度值（毫克/标立方米、毫克/升）",
					groud:"(10)"
				},
				{
					title:"大气、水污染物监测计算",
					mintitle:"*月均浓度（毫克/标立方米、毫克/升）",
					groud:"(11)"
				},
				{
					title:"大气、水污染物监测计算",
					mintitle:"*最高浓度（毫克/标立方米、毫克/升）",
					groud:"(12)"
				},
				{
					title:"产（排）污系数 计算",
					mintitle:"*计算基数",
					groud:"(13)"
				},
				{
					title:"产（排）污系数 计算",
					mintitle:"*产污系数",
					groud:"(14)"
				},
				{
					title:"产（排）污系数 计算",
					mintitle:"*排污系数",
					groud:"(15)"
				},
				{
					title:"固体废物计算",
					mintitle:"*本月固体废物的产生量(吨)",
					groud:"(16)"
				},
				{
					title:"固体废物计算",
					mintitle:"*本月固体废物的贮存量(吨)",
					groud:"(17)"
				},
				{
					title:"固体废物计算",
					mintitle:"*本月固体废物的处置量(吨)",
					groud:"(18)"
				},
				{
					title:"固体废物信息",
					mintitle:"*本月固体废物的综合利用量（吨）",
					groud:"(19)"
				},
				{
					title:"噪声计算",
					mintitle:"*噪声时段",
					groud:"(20)"
				},
				{
					title:"噪声计算",
					mintitle:"*监测分贝数",
					groud:"(21)"
				},
				{
					title:"噪声计算",
					mintitle:"*超标不足 15 天",
					groud:"(22)"
				},
				{
					title:"噪声计算",
					mintitle:"*两处以上噪声超标",
					groud:"(23)"
				},
				{
					title:"抽样测算计算",
					mintitle:"特征指标",
					groud:"(24)"
				},
				{
					title:"抽样测算计算",
					mintitle:"特征单位",
					groud:"(25)"
				},
				{
					title:"抽样测算计算",
					mintitle:"特征指标数量",
					groud:"(26)"
				},
				{
					title:"抽样测算计算",
					mintitle:"特征系数",
					groud:"(27)"
				},
				{
					title:"污染物排放量 (千克或吨)",
					mintitle:"",
					disabledccxwhb_4_x_1:true,
					disabledccxwhb_4_x_2:true,
					disabledccxwhb_4_x_3:true,
					groud:"大气、水污染物监测计算：（28）=(9)×(10)÷100(1000)大气、水污染物产（排）污系数计算：（28）=(13)×(14)×M（28）=(13)×(15)×MpH 值、大肠菌群数、余氯量等水污染物计算：（28）=(9)色度污染物计算：（28）=（9）×色度超标倍数固体废物排放量（含综合利用量）：（28）=(16)-(17)-(18)"
				},
				{
					title:"*污染当量值（特征值）（千克或吨）",
					mintitle:"",
					groud:"(29)"
				},
				{
					title:"*污染当量数",
					mintitle:"",
					groud:"大气、水污染物污染当量数计算：（30）=(28)÷(29)",
					disabledccxwhb_4_x_1:true,
					disabledccxwhb_4_x_2:true,
					disabledccxwhb_4_x_3:true,
				},
				{
					title:"*减免性质代码和项目名称",
					mintitle:"",
					groud:"（31）"
				},
				{
					title:"*单位税额",
					mintitle:"",
					groud:"（32）"
				},
				{
					title:"*本期应纳税额",
					mintitle:"",
					disabledccxwhb_4_x_1:true,
					disabledccxwhb_4_x_2:true,
					disabledccxwhb_4_x_3:true,
					groud:"大气、水污染物应纳税额计算：（33）=(30)×(32)固体废物应纳税额计算：(33)=(28)×(32)噪声应纳税额计算： (33)=0.5 或 1[（22）为是的用 0.5； 为否的用 1]×2 或 1[(23)为是的用 2，为否的用 1]×(32)按照税法所附表二中畜禽养殖业等水污染物当量值表计算：(33)=(26)÷(29)×(32)采用特征系数计算： (33)=(26) × (27) ÷(29)×(32)采用特征值计算： (33)=(26) × (29) ×(32)"
				},
				{
					title:"本期减免税额",
					mintitle:"",
					groud:"大气、水污染物减免税额计算：（34）=(30)× (32)×N固体废物减免税额计算：（34）=(19)×(32)"
				},
				{
					title:"本期已缴税额",
					mintitle:"",
					groud:"（35）"
				},
				{
					title:"*本期应补（退）税额",
					mintitle:"",
					disabledccxwhb_4_x_1:true,
					disabledccxwhb_4_x_2:true,
					disabledccxwhb_4_x_3:true,
					groud:"（36）=(33)-(34)-(35)"
				},
			]
	}
	return obj
}
